<template>
  <div>
    <el-row class="tableHearInputBox" type="flex" justify="space-between">
      <el-col>
        <el-input
          v-model.trim="query.query"
          placeholder="请输入姓名"
          style="width: 200px"
          @keyup.enter.native="frechLoad"
          @clear="
            query.query = '';
            frechLoad();
          "
          clearable
          suffix-icon="el-icon-search"
        ></el-input>
        <Debounce>
          <el-button style="margin: 0px 10px" size="small" @click="frechLoad">查询 </el-button>
        </Debounce>
        <el-select
          style="margin-right: 10px; width: 150px"
          v-model="query.applicationYear"
          @change="changeYear"
          filterable
          placeholder="请选择"
        >
          <el-option
            v-for="item in applicationFilterYearList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select
          style="margin-right: 10px; width: 150px"
          v-model="query.kspc"
          @change="frechLoad"
          filterable
          placeholder="请选择"
        >
          <el-option label="全部批次" value=""></el-option>
          <el-option
            v-for="item in kspcList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select
          style="margin-right: 10px; width: 150px"
          v-model="query.subjectId"
          @change="frechLoad"
          filterable
          placeholder="请选择"
        >
          <el-option label="全部科目" value=""></el-option>
          <el-option v-for="item in subiectList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <el-select
          style="margin-right: 10px; width: 150px"
          v-model="query.provinceId"
          filterable
          @change="frechLoad"
          placeholder="请选择"
        >
          <el-option label="全部省份" value=""></el-option>
          <el-option v-for="item in proList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <el-select
          style="margin-right: 10px; width: 150px"
          v-model="query.examSiteId"
          @change="frechLoad"
          filterable
          placeholder="请选择"
        >
          <el-option label="全部市代" value=""></el-option>
          <el-option v-for="item in examSitList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <el-select
          style="margin-right: 10px; width: 150px"
          v-model="query.registerId"
          @change="frechLoad"
          filterable
          placeholder="请选择"
        >
          <el-option label="全部考点" value=""></el-option>
          <el-option
            v-for="item in rationSiteList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          style="margin-right: 10px; width: 150px"
          v-model="query.paymentStatus"
          @change="frechLoad"
          filterable
          placeholder="请选择"
        >
          <el-option label="缴费状态" value=""></el-option>
          <el-option v-for="item in jfztList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-col>
      <el-button style="float: right" type="primary" @click="exportApplyInfo"
        >导出报名信息</el-button
      >
    </el-row>
    <el-table
      :data="tableList"
      tooltip-effect="dark"
      border
      ref="elTable"
      style="width: 100%; max-height: 650px"
      :header-cell-style="$store.getters.getTableHeadStyle"
      v-loading="tableIsLoad"
      element-loading-text="加载中"
      :height="$store.getters.getTableHeight"
    >
      <el-table-column prop="photo" label="照片" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.photo" style="height: 30px" @click="operatInfo(5, scope.row)" />
        </template>
      </el-table-column>
      <el-table-column prop="name" label="姓名" align="center"></el-table-column>
      <el-table-column prop="surName" label="姓氏拼音" align="center"></el-table-column>
      <el-table-column prop="englishName" label="名字拼音" align="center"></el-table-column>
      <el-table-column prop="sex" label="性别" align="center">
        <template slot-scope="scope">
          {{ scope.row.sex === 1 ? '男' : '女' }}
        </template>
      </el-table-column>
      <el-table-column prop="age" label="年龄" align="center"></el-table-column>
      <el-table-column prop="countryName" label="国籍" align="center"></el-table-column>
      <el-table-column
        width="200px"
        prop="idNumber"
        label="证件号码"
        align="center"
      ></el-table-column>
      <el-table-column width="120px" prop="birth" label="出生日期" align="center"></el-table-column>
      <el-table-column
        width="120px"
        prop="mobile"
        label="联系电话"
        align="center"
      ></el-table-column>
      <el-table-column
        width="200px"
        prop="address"
        label="快递地址"
        align="center"
      ></el-table-column>
      <el-table-column prop="provinceName" label="省份" align="center"></el-table-column>
      <el-table-column
        width="200px"
        prop="examSiteName"
        label="市级代理"
        align="center"
      ></el-table-column>
      <el-table-column
        width="200px"
        prop="registrationPointName"
        label="考点"
        align="center"
      ></el-table-column>
      <el-table-column prop="testLevel" label="报考等级" align="center"></el-table-column>
      <el-table-column
        prop="zdjs"
        show-overflow-tooltip
        label="指导教师"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="zdjsdh"
        show-overflow-tooltip
        label="指导教师电话"
        align="center"
      ></el-table-column>
      <el-table-column width="100px" prop="appYear" label="考试年份" align="center">
        <template slot-scope="scope"> {{ scope.row.appYear }}年 </template>
      </el-table-column>
      <el-table-column prop="kspc" label="考试批次" align="center">
        <template slot-scope="scope">
          {{
            scope.row.kspc === 1
              ? '春季'
              : scope.row.kspc === 2
              ? '夏季'
              : scope.row.kspc === 3
              ? '秋季'
              : scope.row.kspc === 4
              ? '冬季'
              : ''
          }}
        </template>
      </el-table-column>
      <el-table-column
        width="200px"
        prop="subjectName"
        label="报考科目"
        align="center"
      ></el-table-column>
      <el-table-column prop="testLevel" label="报考等级" align="center"></el-table-column>
      <el-table-column width="200px" prop="certificate" label="上传证书" align="center">
        <template slot-scope="scope">
          <a target="_blank" v-if="scope.row.certificate" :href="scope.row.certificate">查看证书</a>
        </template>
      </el-table-column>
      <el-table-column prop="subjectAmount" label="应缴费用" align="center"></el-table-column>
      <!-- <el-table-column prop="paymentMethod" label="缴费方式" align="center">
        <template slot-scope="scope">
          <span  v-if="scope.row.paymentMethod === 1">线上缴费</span>
          <span v-else>线下缴费</span>
          <!-- <span class="pays" v-if="scope.row.paymentStatus === 1">已缴费</span>
          <span class="noPay" v-else>未缴费</span> -->
      <!-- </template>
      </el-table-column>  -->
      <el-table-column prop="paymentStatus" label="缴费状态" align="center">
        <template slot-scope="scope">
          <span class="pays" v-if="scope.row.paymentStatus === 1">已缴费</span>
          <span class="noPay" v-else>未缴费</span>
        </template>
      </el-table-column>
      <el-table-column label="备注" width="120" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-input
            style="width: 96%"
            v-model="scope.row.bz"
            maxlength="50"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            v-if="status == scope.row.id"
            @keyup.enter.native="updateBz(scope.row.id, scope.row.bz)"
          ></el-input>
          <div v-else class="bzContent" @click="clickBz(scope.row)">{{ scope.row.bz }}</div>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      :total="query.total"
      :page.sync="query.pageNum"
      :limit.sync="query.pageSize"
      class="pagination-content"
      @pagination="tableLoad"
    />
  </div>
</template>

<script>
import { exportFile } from '@/uitls/globalFun.js';
export default {
  data() {
    return {
      applicationFilterYearList: [], //年份过滤框
      tableList: [],
      tableIsLoad: false,
      actNum: 'subject',
      proList: [], //省份考点下拉菜单
      registerList: [], //报考等级下拉
      examSitList: [], //市代下拉菜单
      subiectList: [], // 考点下拉框
      // yearList: [],
      // lotList: [],
      kspcList: [
        { value: '1', label: '春季' },
        { value: '2', label: '夏季' },
        { value: '3', label: '秋季' },
        { value: '4', label: '冬季' },
      ],
      rationSiteList: [],
      jfztList: [
        { id: 1, name: '已缴费' },
        { id: 0, name: '未缴费' },
      ],
      query: {
        query: '',
        subjectId: '',
        applicationYear: '',
        kspc: '',
        pageNum: 1, // 当前页
        pageSize: 15, // 每页显示条数
        total: 1, //总条数
        type: 1, //状态 1:已通过 0：待审核
        examSiteId: '', //所属市级代理
        provinceId: '', //所属省份ID
        registerId: '', //考点
        paymentStatus: '', // 缴费状态
        examId: '',
      },
      // lvList: [
      //   { id: 1, lv: "一级" },
      //   { id: 2, lv: "二级" },
      //   { id: 3, lv: "三级" },
      //   { id: 4, lv: "四级" },
      //   { id: 5, lv: "五级" },
      //   { id: 6, lv: "六级" },
      //   { id: 7, lv: "七级" },
      //   { id: 8, lv: "八级" },
      //   { id: 9, lv: "九级" },
      //   { id: 10, lv: "十级" },
      //   { id: 11, lv: "初级" },
      //   { id: 12, lv: "中级" },
      //   { id: 13, lv: "高级" },
      // ],
      exportTicketLoading: false,
      status: 0,
      optionParam: { id: null, bz: null },
    };
  },
  async mounted() {
    await this.getApplicationFilterYearSelect();
    this.getSelectList();
  },
  computed: {
    activeMenu() {
      return this.$route.name;
    },
    uploadUrl() {
      return this.$store.getters['skb/getUploadUrl'];
    },
  },
  methods: {
    getTableRole() {
      let { roleIdList, userName } = this.$store.getters.getUser;
      //如果账号为admin/学校管理员角色
      if (userName === 'admin' || (roleIdList && roleIdList.find((item) => item === '1'))) {
        return true;
      }
      return false;
    },
    updateBz(id, bz) {
      this.status = 0;
      this.$axios
        .post(`/apply/update`, {
          bz,
          id,
        })
        .then((res) => {
          this.$message({
            type: 'success',
            message: '修改成功!',
            duration: 1000,
          });
          this.tableLoad();
        });
    },
    clickBz(val) {
      if (!this.getTableRole()) return;
      if (this.status != 0 && this.optionParam.id != null) {
        this.tableList.forEach((item) => {
          if (item.id == this.optionParam.id) {
            item.bz = this.optionParam.bz;
          }
        });
      }
      this.optionParam = { id: val.id, bz: val.bz };
      this.status = val.id;
    },
    exportApplyInfo() {
      // window.location.href = `/api/apply/export?year=${this.query.applicationYear}`;
      let query = {
        query: this.query.query,
        subjectId: this.query.subjectId,
        applicationYear: this.query.applicationYear ? Number(this.query.applicationYear) : '',
        kspc: this.query.kspc,

        type: 1, //状态 1:已通过 0：待审核
        examSiteId: this.query.examSiteId, //所属市级代理
        provinceId: this.query.provinceId, //所属省份ID
        registerId: this.query.registerId, //考点
        paymentStatus: this.query.paymentStatus, // 缴费状态
        examId: this.query.examId,
      };
      this.exportTicketLoading = true;
      this.$axios.post('/apply/exportStu', query, { responseType: 'blob' }).then((res) => {
        exportFile(res);
        this.exportTicketLoading = false;
      });
    },
    //获取考试年份过滤下拉
    async getApplicationFilterYearSelect() {
      await this.$axios.get('/examInformation/selectFilterData').then((rs) => {
        let appYears = rs.data.data;
        this.applicationFilterYearList = appYears;
        this.query.applicationYear = appYears[0].label;
        this.tableLoad();
      });
    },
    changeYear(val) {
      // this.query.kspc = "";
      // if (val) {
      //   this.lotList = this.yearList.filter((item) => {
      //     return item.parentId == val;
      //   })[0].children;
      // } else {
      //   this.lotList = [];
      // }
      this.frechLoad();
    },
    frechLoad() {
      this.query.pageNum = 1;
      this.tableLoad();
    },
    tableLoad() {
      this.query.applicationYear = this.query.applicationYear
        ? Number(this.query.applicationYear)
        : '';
      this.$axios.post('/apply/stuList', this.query).then((res) => {
        let { list, total } = res.data.data;
        this.tableList = list;
        this.query.total = total;
        this.tableIsLoad = false;
      });
    },

    // 全部下拉菜单
    getSelectList() {
      this.$axios.get('/apply/newProvince').then((res) => {
        let data = res.data.data;
        this.proList = data;
      });
      this.$axios.get('/apply/examinationSite').then((res) => {
        let data = res.data.data;
        this.examSitList = data;
      });
      this.$axios.get('/apply/subjects').then((res) => {
        let data = res.data.data;
        this.subiectList = data;
      });
      // this.$axios.get("/apply/yearLine").then((res) => {
      //   let data = res.data.data;
      //   this.yearList = data;
      //   this.query.applicationYear = this.yearList[0].parentId;
      //   this.lotList = this.yearList[0].children;
      //   this.tableLoad();
      // });
      this.$axios.get('/apply/rationSite').then((res) => {
        let data = res.data.data;
        this.rationSiteList = data;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.noPay {
  color: #ff5353;
  cursor: pointer;
  text-decoration: underline;
}

.pays {
  cursor: pointer;
  text-decoration: underline;
}
.bzContent {
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 省略号 */
}
::v-deep .el-table ::-webkit-scrollbar {
  height: 20px;
}
</style>
